import React from 'react';
import { Loader } from '../../../../../components/common';
import styles from './loader-xsmall.scss';

export const LoaderXSmall: React.FunctionComponent = () => (
  <div className={styles.loaderXSmall}>
    <Loader size="small" />
  </div>
);
